import { useCreateEvent } from "@/features/events/hooks/useCreateEvent";
import { EventType } from "@/features/events/types/EventType";
import useAssignNutritionist from "@/features/experts/hooks/useAssignNutritionist";
import useAssignPhysician from "@/features/experts/hooks/useAssignPhysician";
import { createProduct, findProduct } from "@/utils/apis/order-service";
import { CreateProductChannel } from "@/utils/enums/CreateProductChannel";
import { ProductType } from "@/utils/enums/ProductType";
import { useAuthStore } from "@/utils/stores/useAuthStore";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const useProductRedemption = (code: string) => {
    const { auth } = useAuthStore();
    const [isLoading, setIsLoading] = useState(false)
    const [codeError, setCodeError] = useState<string>("");
    const { assignNutri } = useAssignNutritionist();
    const { assignPhysician } = useAssignPhysician();
    const { sendEvent } = useCreateEvent()
    const navigate = useNavigate()

    const redeemProduct = async () => {
        if (!auth.idToken || !auth.userId) return;

        setIsLoading(true);

        findProduct(
            code,
            auth.idToken,
            async (product) => {
                await sendEvent({
                    event: EventType.PRODUCT_FOUND,
                    sub_category: "redeem",
                    event_metadata: { product },
                });
                const type = product
                createProduct(
                    auth.userId!,
                    auth.idToken!,
                    type,
                    async (success) => {
                        await sendEvent({
                            event: EventType.PRODUCT_SAVED,
                            sub_category: "redeem",
                            event_metadata: { product },
                        });
                        if (type === ProductType.MetabolicHook) {
                            assignPhysician()
                        }
                        if (type === ProductType.Nutritionist) {
                            assignNutri(
                                () => { navigate("/check-purchases") },
                                () => { navigate("/check-purchases") },
                            )
                        } else {
                            navigate("/check-purchases")
                            setIsLoading(false)
                        }
                    },
                    async (error) => {
                        await sendEvent({
                            event: EventType.PRODUCT_NOT_SAVED,
                            sub_category: "redeem",
                            event_metadata: { product },
                        });
                        console.log(error)
                        setIsLoading(false)
                    },
                    {
                        shopify_product: "one-off",
                        channel: CreateProductChannel.RedeemCode,
                        code: code,
                        buyer: null,
                        redeemer: null,
                    }
                )
            },
            async (error) => {
                await sendEvent({
                    event: EventType.PRODUCT_NOT_FOUND,
                    sub_category: "redeem",
                });
                setCodeError(error)
                setIsLoading(false)
            }
        )
    }

    return {
        isLoading,
        codeError,
        setCodeError,
        redeemProduct,
        setIsLoading
    };
}